__turbopack_context__.v({
  "className": "ibm_plex_mono_805f3b2b-module__VKve2q__className",
  "variable": "ibm_plex_mono_805f3b2b-module__VKve2q__variable",
});
